export default __webpack_public_path__ + "static/media/work-icon.8b3e8e28.svg";